export async function kitsIndexUseCase(page, per_page, search, sort_by, kitsRepository) {
    const result = await kitsRepository.index(page, per_page, search, sort_by);

    result.data.data.forEach(x =>  {
        const entity = new kitsRepository.model_index(x);

        if (!entity.isValid()) {
            throw new Error("kit inválido");
        }
    })

    return result.data;
}